import React from 'react';
import styles from '../ManagePage.module.css';
import { formatScoreDate } from './SingleScoreCard';

// First–last ASIN label for a title-update run ("1 ASIN" when there's only one).
const asinRangeLabel = (rows) => {
  if (rows.length <= 1) return '1 ASIN';
  return `${rows[0]?.asin} – ${rows[rows.length - 1]?.asin}`;
};

// Manage-page card for a saved Update Title run. Clicking opens the run inline via
// onOpen (no route change). Blue "Title" badge matches the Score/Deal cards.
const TitleUpdateCard = ({ project, onOpen }) => {
  const rows = Array.isArray(project.results) ? project.results : [];
  const cardImage = rows.find((r) => r.image_url)?.image_url || '';

  return (
    <div
      className={styles.generationCard}
      onClick={() => rows.length > 0 && onOpen(project)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && rows.length > 0) { e.preventDefault(); onOpen(project); } }}
    >
      <div className={styles.recentProjectInner}>
        <div className={styles.cardImage}>
          {cardImage ? (
            <img
              src={cardImage}
              alt="Title update preview"
              className={styles.recentProjectImage}
              loading="lazy"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          ) : (
            <div className={styles.imagePlaceholder}>No Image</div>
          )}
        </div>
        <div className={styles.recentProjectDetails}>
          <div className={styles.recentProjectDetailsTop}>
            <div className={styles.cardTitle}>Title Update</div>
            <div className={styles.recentProjectIdTag}>
              <span>{asinRangeLabel(rows)}</span>
            </div>
          </div>
          <div className={styles.cardDate}>
            <span>{formatScoreDate(project.created_at)}</span>
          </div>
        </div>
      </div>
      <div className={styles.recentProjectScoreBadge}>
        <span>Title</span>
      </div>
    </div>
  );
};

export default TitleUpdateCard;
